import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useCookies } from 'react-cookie';
import { Box, Copy, Link, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './DealerDetailCard.styles';
import { sanitizeUrl, useAppSelector } from '../../core/utils';
import { DEALER_DATA_COOKIE_NAME } from '../../utils/constants';
import { useLanguage } from '../../utils/sitecoreContext';
import formatNumber from '../../utils/formatNumber';
import { pushLeadsCtaEvent } from '../../utils/gtmEvents';
import { selectBodyTypesForGtm, selectCurrentVehicleFromVehicles } from '../../core/reducers/vehicles';
import useFetchCurrentStatus from '../StatusChange/hooks/useFetchCurrentStatus';
const floorParser = (num) => Math.floor(num * 10) / 10;
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const AddressWrapper = themeStyles.apply(Box, 'AddressWrapper');
const HeaderWrapper = themeStyles.apply(Box, 'HeaderWrapper');
const DealerName = themeStyles.apply(Copy, 'DealerName');
const Distance = themeStyles.apply(Copy, 'Distance');
const Address = themeStyles.apply(Copy, 'Address');
const Contact = themeStyles.apply(Link, 'Contact');
const Email = themeStyles.apply(Link, 'Contact');
const Website = themeStyles.apply(Link, 'Contact');
const DealerDetailCard = ({ componentType }) => {
    const [cookies] = useCookies([DEALER_DATA_COOKIE_NAME]);
    const dealerData = cookies === null || cookies === void 0 ? void 0 : cookies.dealerData;
    const { dealerName, dealerAddress, dealerContact, dealerEmail, dealerWebsite, dealerDistance } = dealerData || {};
    const language = useLanguage();
    const currentVehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    const distanceAway = formatNumber(dealerDistance, language, 1, floorParser);
    const { data: inventoryStatus } = useFetchCurrentStatus();
    const gtmPayLoad = {
        event: 'dealer_inventory_cta_click',
        dealer_name: dealerName,
        cta_type: 'cta:contact dealer',
        cta_placement: 'dealer inventory',
        model: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelKey) || '',
        trim: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimName) || '',
        component_type: componentType || '',
        body_style: gtmBodyStyle,
        availability_flag: inventoryStatus || '',
    };
    const { t } = useTranslation();
    const onClickHandler = (url, type, text) => {
        pushLeadsCtaEvent({ ...gtmPayLoad, interaction_type: type, link_text: text, link_url: url });
    };
    return (_jsx(Optional, { when: dealerData, children: _jsx(Wrapper, { "data-testid": "cy-dealer-details-card", children: _jsxs(AddressWrapper, { children: [_jsxs(HeaderWrapper, { children: [_jsx(DealerName, { size: "subheading", "data-testid": "cy-dealer-name", children: dealerName }), !!distanceAway && (_jsx(Distance, { "data-testid": "cy-dealer-distance", children: t('Sub-apps.Dealers.kmAwayLabel', { KMValue: distanceAway }) }))] }), _jsx(Address, { size: "small", "data-testid": "cy-dealer-address", children: dealerAddress }), _jsx(Contact, { href: `tel:${dealerContact}`, disableHover: true, "data-testid": "cy-dealer-contact", onClick: () => onClickHandler(`tel:${dealerContact}`, 'dealer_call', dealerContact), children: dealerContact }), _jsx(Email, { href: `mailto:${dealerEmail}`, styling: "secondary", disableHover: true, "data-testid": "cy-dealer-email", onClick: () => onClickHandler(`mailto:${dealerEmail}`, 'dealer_email', dealerEmail), children: dealerEmail }), _jsx(Website, { href: `http://${sanitizeUrl(dealerWebsite)}`, target: "_blank", styling: "secondary", disableHover: true, "data-testid": "cy-dealer-website", onClick: () => onClickHandler(dealerWebsite, 'dealer_website', dealerWebsite), children: dealerWebsite })] }) }) }));
};
export default DealerDetailCard;
